import { useState } from "react";
import "../gallery.css";

const projects = [
    {
    title: "Modern Luxury Estate",
    before:
        "./images/before_kitchen.jpg",
    after:
        "./images/kitchen.jpg",
    },
    {
    title: "Coastal Family Home",
    before:
        "./images/before_bathroom.jpg",
    after:
        "./images/bathroom.jpg",
    },
    {
    title: "Mountain Retreat",
    before:
        "./images/before_shower2.jpg",
    after:
        "./images/shower.jpg",
    },
    {
    title: "Urban Contemporary",
    before:
        "./images/shower_2.jfif",
    after:
        "./images/shower2.jpg",
    }
];

export default function TransformationGallery() {
    return (
    <section className="transform-section">
        <div className="transform-header">
        <h2>Transformation Gallery</h2>
        <p>See the remarkable before and after of our projects</p>
        </div>

        <div className="transform-grid">
        {projects.map((project, i) => (
            <TransformationCard key={i} project={project} />
        ))}
        </div>
    </section>
    );
}

function TransformationCard({ project }) {
    const [view, setView] = useState("before");

    return (
    <div className="transform-card">
        <h3>{project.title}</h3>

        <div className="toggle">
        <button
            className={view === "before" ? "active" : ""}
            onClick={() => setView("before")}
        >
            Before
        </button>
        <button
            className={view === "after" ? "active" : ""}
            onClick={() => setView("after")}
        >
            After
        </button>
        </div>

        <div className="image-wrapper">
        <img
            src={view === "before" ? project.before : project.after}
            alt={project.title}
            key={view}
            className="fade"
        />
        <span className="badge">{view}</span>
        </div>
    </div>
    );
}